import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import idx from 'idx';
import { sendFeedback, getProjectRevisions } from 'project/ducks/revisions';
import { getProjectEntries, getProjectEntriesState, dismissFeedback } from 'project/ducks/entries';
import { getProject } from 'project/ducks/project';
import { getSubcategorySlug } from 'common/ducks/categories';

import NegativeFeedback from 'project/components/entries/negative_feedback';

export const FORM_NAME = 'REVISION_FEEDBACK_NEGATIVE';

export function validate(values) {
  const errors = {};

  if (values.feedbackTextCheckbox && !values.feedback) {
    errors.feedback = 'Please enter some feedback';
  }

  if (values.feedback && !values.feedback.trim()) {
    errors.feedback = 'Please enter some feedback';
  }

  return errors;
}

export function mapStateToProps(state) {
  const { scoredRevision } = getProjectEntriesState(state);
  const { entry } = getProjectRevisions(state)[scoredRevision];
  const { author_username } = getProjectEntries(state)[entry];

  return {
    author_username,
    subcatSlug: getSubcategorySlug(state.categories, idx(getProject(state), _ => _.sub_category))
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: sendFeedback,
    onHide: dismissFeedback,
  }, dispatch);
}

const NegativeFeedbackForm = reduxForm({
  form: FORM_NAME,
  validate,
})(NegativeFeedback);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NegativeFeedbackForm));



// WEBPACK FOOTER //
// ./project/containers/entries/negative_feedback.js